import { useRouter } from 'next/router'

export const useHashROuter = () => {
  const router = useRouter()
  let hash_name = router.asPath.split('#')[1]

  return { ...router, hash_name: hash_name ? hash_name : '0' }
}
